const translations = {
    'nl' : {
        "screen_historical_reports": "Historisch overzicht",
        "screen_historical_reports_Company_Name": "naam bedrijf",
        "screen_historical_reports_date":"datum rapport",
        "screen_historical_nnv":"geschoonde nominale boekwaarde debiteurenportefeuille",
        "screen_historical_liquidation":"indicatieve liquidatiewaarde",
        "screen_historical_reports_See_detailed_report":"rapportage",
        "screen_historical_reports_Download":"download",
        "screen_historical_reports_btn_new_report": "Start waardebepaling",
        "screen_historical_reports_user_name": "naam gebruiker",
        "screen_historical_liquidation_value": "indicatieve liquidatiewaarde",

        "screen_create_report_btn_create_report": "Start waardebepaling",
        "screen_create_report_top_step1": "algemene informatie",

        "screen_reportintroduction__please_select_type" : "selecteer de branche waarin de onderneming actief is",
        "screen_reportintroduction__start_new_report" : "Start nieuwe waardebepaling",

        "screen_create_report_description_hello": "Welkom, start een nieuwe waardebepaling door de volgende stappen te doorlopen:",
        "screen_create_report_description_process": "Het process is eenvoudig en kent vier stappen:",
        "screen_create_report_description_process_step_1": "Invullen basis gegevens",
        "screen_create_report_description_process_step_2": "Beantwoorden van enkele specifieke vragen ten aanzien van (zaken rondom) de debiteurenportefeuille",
        "screen_create_report_description_process_step_3": "Controleer en bevestig de gegeven antwoorden",
        "screen_create_report_description_process_step_4": "M2intel genereert een rapportage met liquidatiewaarde van de debiteurenportefeuille op basis van stap 1, 2 en 3",

        "screen_create_report_btn_skip": "overslaan",
        "screen_create_report_branch_list_desc1": "selecteer de branche waarin de onderneming actief is",

        "screen_create_report_general_industry": "branche",
        "screen_create_report_general_general_information": "algemene informatie",
        "screen_create_report_general_label_nominal_carrying": "nominale boekwaarde portefeuille",
        "screen_create_report_general_label_nominal_carrying_geshonde": "nominale boekwaarde portefeuille",
        "screen_create_report_general_label_geschoonde_nominal_carrying": "geschoonde nominale boekwaarde portefeuille",
        "screen_create_report_general_label_Reference_Date_Debtor_Portfolio": "peildatum debiteurenportefeuille",
        "screen_create_report_general_placeholder_Reference_Date_Debtor_Portfolio": "dit betreft de datum van de (geconsolideerde) debiteurenportefeuille (\"de peildatum\")",
        "screen_create_report_general_label_Borrowers_Name": "(code) naam kredietnemer",
        "screen_create_report_general_label_Nominal_Carrying_Amount_Debtor_Portfolio": "nominale boekwaarde debiteurenportefeuille",
        "screen_create_report_general_placeholder_Nominal_Carrying_Amount_Debtor_Portfolio": "de waarde van de debiteurenportefeuille in € '000'",
        "screen_create_report_general_tip_Nominal_Carrying_Amount_Debtor_Portfolio" : "dit veld mag niet leeg zijn. Invoer van het getal \"0\" betekent \"niet bekend\"",
        "screen_create_report_general_label_user_comments": "opmerkingen ",

        "screen_create_report_general_label_pledging_prohibitions": "Overige correcties",
        "screen_create_report_general_label_debiteur_creditor_positions": "Debiteur crediteur posities",
        "screen_create_report_general_label_provision_for_debtors": "Intercompany vorderingen",

        "general_type": "Type",
        "general__general_informations": "algemene informatie",
        "general__summary": "Samenvatting",
        "general__answers": "Antwoorden",
        "general__score": "Score",
        "general__number_of_pages": "",
        "general__branch_name": "branche",
        "general__total_max": "Total Max Score",
        "general__process_progress": "Procesvoortgang",
        "general__back": "Terug",
        "general__continue": "Voortzetten",
        "general__download": "Download",
        "general__cancel_report": "Cancel report",
        "general__required": "verplicht veld",
        "general__requires_numbers": "Field requires only numeric values",
        "report_generated_notice": "Report generated",

        "logout": "Logout"

    }
}

export default translations;
